import { isCampaignEnabled } from '../../jsCore/config/campaignConfig'
import { external as externalScriptLoader } from '../../jsCore/utils/script'
import { externalScriptsConfig } from '../../jsCore/organizedByType/config/externalScripts'
import { register } from '../../components/viewability/viewbilityTracker'
import { getCountryCode } from '../../jsCore/providers/geolocationProvider'

const FRESH_EIGHT_CONFIG = {
  whiteListCountryCodes: ['FR', 'IL', 'IT', 'ES'],
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
}

function addPlaceHolder() {
  getCountryCode().then(response => {
    let paragraph = document.querySelectorAll('.post-content > p')[2]
    if (response === 'IT') {
      paragraph = document.querySelectorAll('.post-content > p')[0]
    }
    if (paragraph !== undefined && paragraph !== null) {
      paragraph.insertAdjacentHTML(
        'afterEnd',
        '<div class="freshEightPlaceHolder" data-viewability="fresh8_betball"><div id="f8-2"></div><div id="f8-1"></div></div>'
      )
    }
  })
}

function getScript() {
  return getCountryCode().then(response => {
    if (response === 'IL') {
      return { src: externalScriptsConfig.freshEightUK.src, name: 'freshEightUK' }
    } else if (response === 'FR') {
      return { src: externalScriptsConfig.freshEightFR.src, name: 'freshEightFR' }
    } else if (response === 'IT') {
      return { src: externalScriptsConfig.freshEightIT.src, name: 'freshEightIT' }
    } else if (response === 'ES') {
      return { src: externalScriptsConfig.freshEightES.src, name: 'freshEightES' }
    }
  })
}

function injectScript() {
  return getScript().then(response => {
    externalScriptLoader.load({
      config: {
        src: response.src,
        name: response.name,
      },
      loadNow: true,
    })
  })
}

export function injectFreshEight() {
  isCampaignEnabled(FRESH_EIGHT_CONFIG).then(response => {
    if (response.isCampaignEnabled) {
      addPlaceHolder()
      injectScript()
      register('.freshEightPlaceHolder')
    }
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fresh8/freshEightInjector.js